import styled from "styled-components";

import {
  borderRadius,
  borderStyle,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { KG_DATA_SOURCE_TEXT_STACK_GAP_PX } from "../../kg/kgNodeDimensions";
import {
  kgNodeEllipsisTextCenterStyles,
  kgNodeTextContainerStyles,
} from "../../kg/kgNodeText.styles";

/** Figma 2178:114848 — icon-view hover detail card. */
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing[3]};
  padding: ${spacing[2]};
  border-radius: ${borderRadius.xl};
  border: ${borderWidth[1]} ${borderStyle.solid}
    ${({ theme }) => theme.colors.border.default};
  background: ${({ theme }) => theme.colors.background.primary};
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.1);
  pointer-events: none;
  white-space: nowrap;
  max-width: 220px;
`;

export const TextStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${KG_DATA_SOURCE_TEXT_STACK_GAP_PX}px;
  ${kgNodeTextContainerStyles}
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${spacing[1]};
  ${kgNodeTextContainerStyles}
`;

export const Title = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.primary};
  ${kgNodeEllipsisTextCenterStyles}
`;

export const Subtitle = styled.span`
  ${typographyMixin("overline", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
  ${kgNodeEllipsisTextCenterStyles}
`;
